import { render } from "./Notification-Badge.vue?vue&type=template&id=8cd824be&scoped=true"
import script from "./Notification-Badge.vue?vue&type=script&lang=js"
export * from "./Notification-Badge.vue?vue&type=script&lang=js"

import "./Notification-Badge.vue?vue&type=style&index=0&id=8cd824be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cd824be"]])

export default __exports__